// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    MIC_SECTOR_LOADING() {
      return {
        isLoading: true
      };
    },
    MIC_SECTOR_LOADED() {
      return {
        isLoading: false,
        data: action.micSector,
        year: action.year,
        sector: action.sector
      };
    },
    MIC_SECTOR_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micSector.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
